import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type UseNextStepsExperiment = ModelHookResult<{
	isEnabled: boolean;
}>;

export function useNextStepsExperiment(): UseNextStepsExperiment {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceNextStepsExperiment: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			isEnabled: variation === 'enabled',
		},
	};
}
